import ReviewPage from "./pages/ReviewPage";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, Protected } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewKit from "./pages/NewKit";
import FounderPage from "./pages/FounderPage";
import CustomerPreview from "./pages/CustomerPreview";
import KitDetail from "./pages/KitDetail";
import Catalog from "./pages/Catalog";
import Orders from "./pages/Orders";
import Delivery from "./pages/Delivery";
import Bespoke from "./pages/Bespoke";
import BespokeKits from "./pages/BespokeKits";
import Production from "./pages/Production";
import Register from "./pages/Register";
import PlanTrip from "./pages/PlanTrip";
import ExtrasShell from "./components/extras/ExtrasShell";
import ExtrasLibrary from "./pages/extras/Library";
import ExtrasNew from "./pages/extras/NewProduct";
import ExtrasProduct from "./pages/extras/Product";
import ExtrasUsage from "./pages/extras/Usage";
import ExtrasBundle from "./pages/extras/BundleNew";
import ExtrasFeed from "./pages/extras/FeedCheck";
import VideoBulk from "./pages/VideoBulk";
import PublicProduct from "./pages/extras/PublicProduct";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/p/:slug" element={<PublicProduct />} />
          <Route path="/founders/:slug" element={<FounderPage />} />
          <Route path="/preview/:token" element={<CustomerPreview />} />
          <Route path="/download/:token" element={<Delivery />} />
          <Route path="/plan-my-trip" element={<PlanTrip />} />
          <Route path="/review/:token" element={<ReviewPage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/new" element={<NewKit />} />
            <Route path="/kits/:id" element={<KitDetail />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/bespoke" element={<Bespoke />} />
            <Route path="/bespoke-kits" element={<BespokeKits />} />
            <Route path="/register" element={<Register />} />
            <Route path="/production" element={<Production />} />
            <Route path="/video-prompts" element={<VideoBulk />} />
            <Route path="/jobs" element={<Navigate to="/?filter=running" replace />} />
            <Route path="/extras" element={<ExtrasShell />}>
              <Route index element={<ExtrasLibrary />} />
              <Route path="new" element={<ExtrasNew />} />
              <Route path="products/:id" element={<ExtrasProduct />} />
              <Route path="usage" element={<ExtrasUsage />} />
              <Route path="bundles/new" element={<ExtrasBundle />} />
              <Route path="feed" element={<ExtrasFeed />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
